import { generalHrefHoc } from './GeneralHrefComponent';
import NewTabHref from './GeneralHrefComponent';

const CertificateHrefAdmin = ({ id, ...rest }) => {
  return <NewTabHref {...rest} link={`/administration/certificates/edit/${id}`} />
}

export default generalHrefHoc(CertificateHrefAdmin);